/**
 * Injects the Open ai Pixel script
 */
export function injectOpenAi({ pixelId, enabled, debugMode }: { pixelId: string, enabled: boolean, debugMode: boolean }) {
  if (!enabled || !pixelId) {
    return
  }

  return {
    key: 'openai-ads',
    type: 'text/javascript' as const,
    innerHTML: injectOpenAiScript({ pixelId, debugMode }),
  }
}

function injectOpenAiScript({ pixelId, debugMode }: { pixelId: string, debugMode: boolean }) {
  // Modified to be injected at the end of the head tag
  return `!function(w,d,s,u){if(w.oaiq)return;var q=function(){q.q.push(arguments)};q.q=[];w.oaiq=q;var j=d.createElement(s);j.async=1;j.src=u;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(j,f)}(window,document,"script","https://bzrcdn.openai.com/sdk/oaiq.min.js");oaiq("init",{pixelId:"${pixelId}",debug:${debugMode}});`
}
